// extracted by mini-css-extract-plugin
module.exports = {"modal":"Settings_modal__1nyKM","input":"Settings_input__2IkKs"};